export default __webpack_public_path__ + "static/initial-dark-28d8dc36468f67cafaf914b75541925f.png";